import type { FC } from 'react';
import { useEffect, useState } from 'react';
import cx from 'classnames';
import { TickCircleIcon } from '@THC/components/Icons';
import { MDText } from 'i18n-react';

import LocalTexts from '../../AiCompanion.texts';

import styles from './ThinkingSteps.module.scss';

const LocalT = new MDText(LocalTexts);

const STEP_INTERVAL_MS = 5000;

const STEPS = [
	LocalT.translate('thinkingSteps.step1') as string,
	LocalT.translate('thinkingSteps.step2') as string,
	LocalT.translate('thinkingSteps.step3') as string,
];

export const ThinkingSteps: FC = () => {
	const [activeStep, setActiveStep] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setActiveStep((prev) => (prev < STEPS.length - 1 ? prev + 1 : prev));
		}, STEP_INTERVAL_MS);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className={styles.wrapper}>
			{STEPS.map((step, index) => {
				const isActive = index === activeStep;

				return (
					<div key={step} className={cx(styles.step, isActive && styles.active)}>
						<span className={isActive ? styles.activeIcon : styles.inactiveIcon}>
							<TickCircleIcon />
						</span>
						<span>{step}</span>
					</div>
				);
			})}
		</div>
	);
};
